import { mount } from '../../../js/dom-lifecycle';

mount('#source-fields', function () {
    const sourceFields = this;
    const config = [
        { selector: '.related-entry', highlight: 'bg-info text-white' },
        { selector: '.duplicate-entry', highlight: 'bg-danger text-white' },
    ].find(c => document.querySelector(c.selector));

    if (!config) return;

    const $entries = $(config.selector);
    let visibleEntry = $entries[0];

    const updateHighlights = () => {
        const matched = $(visibleEntry).data('matched') || [];
        $(sourceFields).find('tr').each((_, tr) => {
            $(tr).find('td span').toggleClass(config.highlight, matched.includes($(tr).data('field')));
        });
    };

    const observer = new IntersectionObserver((items) => {
        items.forEach((item) => {
            if (item.isIntersecting && item.intersectionRatio > 0.3) {
                visibleEntry = item.target;
                updateHighlights();
            }
        });
    }, { root: $('.position-absolute.overflow-auto')[0], threshold: [0.3, 0.5, 0.7, 1] });

    $entries.each((_, el) => observer.observe(el));
    updateHighlights();
});
